type DisplayPaymentReference<T extends string> = { type: T; value: string };

// Resolves what to show for a wire's payment identifiers: one row per structured payment
// reference (IMAD/OMAD/UETR/MIR) when present, falling back to a single legacy row (e.g. "IMAD")
// for operations that predate the paymentReferences field (deploy skew / old data).
export function getWireDisplayReferences<T extends string>(
  paymentReferences:
    | ReadonlyArray<DisplayPaymentReference<T>>
    | null
    | undefined,
  legacyType: T,
  legacyValue: string | null | undefined,
): Array<DisplayPaymentReference<T>> {
  const usableReferences = (paymentReferences ?? []).filter(
    ({ value }) => value.trim().length > 0,
  );

  if (usableReferences.length > 0) {
    return usableReferences;
  }
  // An empty result lets callers fall through to their own placeholder rather than rendering a
  // labelled row with nothing in it.
  return legacyValue?.trim() ? [{ type: legacyType, value: legacyValue }] : [];
}
